import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationService } from '@fgb/portal-component-library/src/lib/shared/services';

@Component({
  templateUrl: 'ecash-failure-page.component.html',
  styleUrls: ['ecash-failure-page.component.scss'],
  selector: 'fgb-ecash-failure',
})
export class EcashFailurePageComponent implements OnInit, OnDestroy {
  constructor(private navigationService: NavigationService) {}

  ngOnInit(): void {
    this.navigationService.hideMobileNav();
  }

  ngOnDestroy(): void {
    this.navigationService.showMobileNav();
  }
}
